//aaa 1.1.1.1:80s
function upstream_str2list_domain(svar){
    const arr = svar && svar.split('\n').filter(line => line.length > 6) || [];
    const newArr = arr.map(item => {
        const arr2 = item && item.split(/\ /g) || [];  // aaa, 1.1.1.1:80s
        const ip_port = arr2[1] || '';
        const arr3 = ip_port.split(':')
        const str2 = arr3[1] || '';
        let isSSL = false;
        let port = '';
        if (str2 && str2.endsWith('s')) {
            isSSL = true;
            port = str2.substr(0, str2.length - 1);
        } else {
            port = str2;
        }
        return {
            prefix: arr2[0],
            addr: arr3[0],
            port,
            isSSL
        };
    });
    return newArr;
}

//1.1.1.1:80s
function upstream_str2list(svar){
    const arr = svar && svar.split('\n').filter(line => line.length > 6) || [];
    const newArr = arr.map(item => {
        const arr2 = item && item.split(/\:/g) || [];
        const str2 = arr2[1] || '';
        let isSSL = false;
        let port = '';
        if (str2 && str2.endsWith('s')) {
            isSSL = true;
            port = str2.substr(0, str2.length - 1);
        } else {
            port = str2;
        }
        return {
            addr: arr2[0],
            port,
            isSSL
        };
    });
    return newArr;
}

function upstream_list2str(mylist){

}

export {upstream_str2list_domain, upstream_str2list, upstream_list2str};
